<template>
  <vg-card>
    <vg-form>
      <vg-field
          v-for="profitCenter in profitCenters"
          :key="profitCenter.profitCenterId"
          :label="profitCenter.projectName"
          is-link
          @click="pick(profitCenter)"
      />
    </vg-form>
  </vg-card>
</template>
<script>

import useProfitCenterPickerStore from "@/store/profit-center-picker-store";
import {mapState} from "pinia";
import VgCard from "@/components/Commons/VgCard.vue";
import VgField from "@/components/Commons/VgField.vue";
import VgForm from "@/components/Commons/VgForm.vue";

export default {
  name: "ProfitCenterPickerView",
  components: {
    VgForm,
    VgField,
    VgCard,
  },
  props: {},
  computed: {
    ...mapState(useProfitCenterPickerStore, ['profitCenters'])
  },
  created() {
    const cheetahId = this.$route.params.cheetahId;
    const projectCenterPicker = useProfitCenterPickerStore();
    projectCenterPicker.load(cheetahId);
  },
  methods: {
    pick(profitCenter) {
      const projectCenterPicker = useProfitCenterPickerStore();
      projectCenterPicker.pick(profitCenter);
      this.$router.go(-1)
    },
  },
};
</script>
<style scoped>
.choice-list {
  width: 353px;
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 10px;
}

.title {
  padding: 10px;
}

.choice-project-button {
  width: 70px;
  height: 36px;
  float: right;
  margin-top: -40px;
  margin-right: 40px;
}

.choice-project-search >>> .van-icon-search:before {
  content: '';
}

.choice-project-search {
  width: 275px;
  height: 44px;
  /* float: left; */
}

.choice-project-search >>> .van-search__content {
  border: 1px solid #E7E5E7;
  background-color: white;
}
</style>
